import useApiCall from 'contexts/ApiCall';
import { useUserContext } from 'contexts/UserContext';
import Badge from 'models/Badge';
import React, { useEffect, useState } from 'react';
import userService from 'services/userService';
import Modal from '../Modal';
import Form from '../Form';

import 'view/style/student/badges.css';

const BadgesDisplay: React.FC = () => {
  const { user } = useUserContext();
  const [badges, setBadges] = useState<Badge[]>([]);
  const [error] = useState<string>();
  const [selectedBadge, setSelectedBadge] = useState<Badge | null>(null);
  const makeApiCall = useApiCall();

  // on mount, load earned badges
  useEffect(() => {
    makeApiCall(userService.getUserBadges, user?.id)
      .then((resp) => setBadges(resp))
      .catch((error) => alert(error));
  }, [user?.id, makeApiCall]);

  return (
    <div className="app-main-content">
      <h1>Your Badges</h1>
      {error && <div className="error">{error}</div>}

      <div className="badges-grid">
        {badges.length === 0 ? (
          <p>No badges earned yet.</p>
        ) : (
          badges.map((badge) => (
            <div
              key={`badge-${badge.id}`}
              className="badge-item clickable"
              onClick={() => setSelectedBadge(badge)}
            >
              <img className="badge" src={badge.image} alt={badge.name} />
              <span className="label-normal">
                <b>{badge.display_name}</b>
              </span>
            </div>
          ))
        )}
      </div>

      <Modal
        isOpen={selectedBadge !== null}
        onClose={() => setSelectedBadge(null)}
      >
        <Form style={{ width: 'min(90vw, 500px)' }}>
          <div className="badge-item">
            <img
              className="badge"
              src={selectedBadge?.image}
              alt={selectedBadge?.name}
            />
            <span className="label-normal">
              <b>{selectedBadge?.display_name}</b>
            </span>
          </div>
          <label className="label-large">Description</label>
          <span className="label-normal">{selectedBadge?.description}</span>
          <label className="label-large">Achievement</label>
          <span className="label-normal">{selectedBadge?.criteria}</span>
        </Form>
      </Modal>
    </div>
  );
};

export default BadgesDisplay;
